import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button, Container, Alert, Spinner } from 'react-bootstrap';
import { API_BASE_URL } from '../../config/constants';
import { auth } from '../login/FirebaseConfig';
import { useNavigate } from 'react-router-dom';

const CrearCategoriaRestoyBar = () => {
    const [nombre, setNombre] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const COLLECTION_RESTOYBAR_NAME = "restoybar";

    const handleCancelar = async () => {
        navigate('/administradorRestoyBar');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError(null);

        if (!nombre) {
            setError('El campo nombre es obligatorio');
            return;
        }

        setLoading(true);

        try {
            const idToken = await auth.currentUser.getIdToken();
            const response = await axios.post(
                `${API_BASE_URL}/crearDocumento`,
                { collectionName: COLLECTION_RESTOYBAR_NAME, documentName: nombre },
                {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                }
            );
        } catch (error) {
            setError('Error al crear la categoría');
        } finally {
            setLoading(false);
            navigate("/administradorRestoyBar");
            window.location.reload();
        }
    };

    return (
        <Container className="mt-5 divfill">
            <h3>Crear Categoría</h3>
            {error && <Alert variant="danger">{error}</Alert>}

            <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formNombre">
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Ingrese el nombre de la categoría"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                    />
                </Form.Group>

                <Button variant="primary" type="submit" className="my-2" disabled={loading}>
                    {loading ? (
                        <Spinner animation="border" size="sm" />
                    ) : (
                        'Crear Categoría'
                    )}
                </Button>
                <Button type="button" className="btn btn-danger my-2 mx-2" onClick={handleCancelar}>Cancelar</Button>
            </Form>
        </Container>
    );
};

export default CrearCategoriaRestoyBar;
